
module.exports = [
  'M4 2 L4 30 L28 30 L28 10 L20 2 z'
].join(' ')




/*****************
 ** WEBPACK FOOTER
 ** ./~/geomicons-open/src/paths/file.js
 ** module id = 208
 ** module chunks = 0
 **/